(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojave-audio-landing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('[data-mojave-root]');
    if (!roots.length) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function(root) {
      // Reveal on scroll
      var revealTargets = root.querySelectorAll('.mj-reveal');
      if (revealTargets.length) {
        if (reduceMotion || !('IntersectionObserver' in window)) {
          revealTargets.forEach(function(el) { el.classList.add('is-visible'); });
        } else {
          var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                io.unobserve(entry.target);
              }
            });
          }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
          revealTargets.forEach(function(el) { io.observe(el); });
        }
      }

      // FAQ accordion (single-open)
      var faqLists = root.querySelectorAll('[data-mojave-faq]');
      faqLists.forEach(function(list) {
        var triggers = list.querySelectorAll('[data-mojave-faq-trigger]');

        function closePanel(trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          var panelId = trigger.getAttribute('aria-controls');
          var panel = document.getElementById(panelId);
          if (!panel) return;
          panel.style.maxHeight = '0px';
          panel.setAttribute('hidden', '');
        }

        function openPanel(trigger) {
          trigger.setAttribute('aria-expanded', 'true');
          var panelId = trigger.getAttribute('aria-controls');
          var panel = document.getElementById(panelId);
          if (!panel) return;
          panel.removeAttribute('hidden');
          // Force reflow then set max-height
          var height = panel.scrollHeight;
          panel.style.maxHeight = height + 'px';
        }

        function toggle(trigger) {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          // Close others (single-open)
          triggers.forEach(function(t) {
            if (t !== trigger && t.getAttribute('aria-expanded') === 'true') {
              closePanel(t);
            }
          });
          if (isOpen) {
            closePanel(trigger);
          } else {
            openPanel(trigger);
          }
        }

        triggers.forEach(function(trigger, i) {
          trigger.addEventListener('click', function(e) {
            e.preventDefault();
            toggle(trigger);
          });
          trigger.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              toggle(trigger);
            } else if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
              closePanel(trigger);
              trigger.focus();
            } else if (e.key === 'ArrowDown') {
              e.preventDefault();
              var next = triggers[i + 1] || triggers[0];
              next.focus();
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              var prev = triggers[i - 1] || triggers[triggers.length - 1];
              prev.focus();
            }
          });
        });

        // Recalculate open panel height on resize
        window.addEventListener('resize', function() {
          triggers.forEach(function(t) {
            if (t.getAttribute('aria-expanded') === 'true') {
              var panelId = t.getAttribute('aria-controls');
              var panel = document.getElementById(panelId);
              if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trash-talk-audio-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-tta-root]');
    if (!roots.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      if (root.dataset.ttaReady === '1') return;
      root.dataset.ttaReady = '1';
      root.classList.add('tta--js');

      /* ── La FAQ usa <details> nativo: ya no necesita JavaScript ────── */

      /* ── Miniaturas de YouTube: cadena de respaldo ────────────────────
         No todos los videos publican `maxresdefault` ni `oardefault`. Cuando la
         miniatura pedida no existe, YouTube NO responde 404: devuelve un 200 con
         una imagen gris de 120×90, así que el evento `error` nunca se dispara y
         la tarjeta queda con un placeholder. Por eso el criterio es el tamaño
         real de la imagen, no el error de red. */
      root.querySelectorAll('[data-tta-thumb-fallback]').forEach(function (img) {
        function nextSource() {
          var queue = (img.getAttribute('data-tta-thumb-fallback') || '')
            .split('|')
            .filter(Boolean);
          if (!queue.length) return;
          img.setAttribute('data-tta-thumb-fallback', queue.slice(1).join('|'));
          img.src = queue[0];
        }
        function check() {
          if (img.naturalWidth === 0 || img.naturalWidth <= 120) nextSource();
        }
        img.addEventListener('error', nextSource);
        img.addEventListener('load', check);
        if (img.complete) check();
      });

      /* ── Fachada de video: el iframe se crea sólo al hacer clic ───── */
      root.querySelectorAll('[data-tta-video]').forEach(function (facade) {
        facade.addEventListener('click', function (event) {
          event.preventDefault();
          var id = facade.getAttribute('data-tta-video');
          var title = facade.getAttribute('data-tta-video-title') || 'Video de YouTube';
          if (!id) return;

          var frame = document.createElement('iframe');
          frame.className = 'tta-video__frame';
          frame.setAttribute('title', title);
          frame.setAttribute(
            'src',
            'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0'
          );
          frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
          frame.setAttribute('allowfullscreen', '');
          frame.setAttribute('loading', 'lazy');

          facade.replaceWith(frame);

          /* Quien llegó al video con el teclado se quedaba sin foco al desaparecer
             el enlace: se lo devolvemos al reproductor recién insertado. */
          frame.setAttribute('tabindex', '-1');
          try {
            frame.focus({ preventScroll: true });
          } catch (err) {
            frame.focus();
          }
        });
      });

      /* ── Aparición al hacer scroll ────────────────────────────────── */
      var revealables = root.querySelectorAll('.tta-reveal');
      if (reduce || !('IntersectionObserver' in window)) {
        revealables.forEach(function (el) {
          el.classList.add('is-in');
        });
        return;
      }

      /* Los elementos que entran juntos al viewport se escalonan: sin esto, las
         tres columnas de color o las tres fotos de escena aparecían como un solo
         bloque y la animación se leía como un salto, no como una entrada. */
      var observer = new IntersectionObserver(
        function (entries) {
          var batch = entries.filter(function (entry) {
            return entry.isIntersecting;
          });
          batch.forEach(function (entry, index) {
            var delay = Math.min(index, 5) * 70;
            entry.target.style.setProperty('--tta-delay', delay + 'ms');
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
      );

      revealables.forEach(function (el) {
        observer.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
